export enum FeedEvent {
  CREATED = 'CREATED',
  REMOVED = 'REMOVED',
  LIKED = 'LIKED',
  UNLIKED = 'UNLIKED',
}

export const feedGlobalCountPlaceholder = '{{count}}'

export enum FeedType {
  GLOBAL = 'GLOBAL',
  USER = 'USER',
}

export const feedTypeDefault = FeedType.GLOBAL

export enum FeedItemType {
  // Custom feed item uploaded by an admin
  CUSTOM = 'CUSTOM',

  // Feed item when a booking (ticket/package/table) was complete
  BOOKING_COMPLETE = 'BOOKING_COMPLETE',

  // Feed item when a user redeems a promo code for credit
  PROMO_REDEEMED = 'PROMO_REDEEMED',

  // Feed item when a user referred a friend
  REFERRAL_REDEEMED = 'REFERRAL_REDEEMED',

  // Feed item when a good review was left by a user
  REVIEW_SUBMITTED = 'REVIEW_SUBMITTED',

  // Feed item when a ticket is checked in
  TICKET_CHECKED_IN = 'TICKET_CHECKED_IN',

  // feed item when a user join Tablelist
  USER_REGISTERED = 'USER_REGISTERED',
}

export const feedItemTypeDefault = FeedItemType.CUSTOM

export enum FeedItemLinkType {
  VENUE = 'VENUE', // View a single venue
  EVENT = 'EVENT', // View a single event
  BOOKING = 'BOOKING', // View a booking
  CITY = 'CITY', // View a city
  REWARD = 'REWARD', // View a reward
  CURATED_LIST = 'CURATED_LIST', // view an external site
  EXTERNAL = 'EXTERNAL', // view an external site
}
